import * as React from 'react'
import 'styles/App.scss'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { parse } from 'query-string'

export default function AppComponent () {
  const domain = parseHostname().publicationDomain
  const search = parse(location.search)

  switch (search['img']) {
    case 'leak':
      return (
        <div className='index'>
          <img src={require('./leak.png')} alt='Der Umfang der Papiere' />
        </div>
      )

    case 'personen':
      return (
        <div className='index'>
          <img
            src={require('./personen.png')}
            alt='Die Personen, die in den Paradise Papers gefunden werden können'
          />

          <a id='ribar' href={`https://www.${domain}/13540148`} target='_top' />
          <a
            id='bastos'
            href={`https://www.${domain}/22853426`}
            target='_top'
          />
          <a
            id='glasenberg'
            href={`https://www.${domain}/30374352`}
            target='_top'
          />
          <a id='ross' href={`https://www.${domain}/16948838`} target='_top' />
        </div>
      )

    case 'laender':
      return (
        <div className='index'>
          <img
            src={require('./laender.png')}
            alt='Die Länder: mit diesen Staaten hatte Appleby am meisten Verbindugen. USA: 31180, Grossbritannien: 14434, Bermudas: 12017, Kayman-Inseln: 8640, Hongkong: 7065, China: 5924, Kanada: 3176, Isle of Man: 3054, Schweiz: 2363.'
          />
        </div>
      )

    case 'vergleich':
      return (
        <div className='index'>
          <img src={require('./vergleich.png')} alt='Die Lecks im Vergleich' />
        </div>
      )

    default:
      return null
  }
}



// WEBPACK FOOTER //
// ./src/components/main/index.js